import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-BoldNew.woff2';
import woff from '../src/PPMori-BoldNew.woff';

export const ppMoriBold: FontFaceSpec = {
  weight: 700,
  style: 'normal',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
